(() => {
  'use strict';
  const root = document.querySelector('#upvine-home-anniversary [data-logo-decade]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized='true';
  const canvas = root.querySelector('canvas'), ctx = canvas.getContext('2d');
  if (!ctx) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const poster = root.hasAttribute('data-poster');
  const TAU = Math.PI * 2, END = 2600, HOLD = 3000, FADE = 650, CYCLE = END + HOLD + FADE;
  const white = '#f3f7f4', green = '#00bc63';
  const clamp = v => Math.max(0, Math.min(1, v));
  const smooth = v => { v = clamp(v); return v * v * (3 - 2 * v); };
  const lerp = (a, b, p) => a + (b - a) * p;
  const phase = (t, a, b) => smooth((t - a) / (b - a));
  // Clean vector lettering follows the storefront mark without the stepped raster edge.
  const letters = [
    'M3 38H17L12 63H26L32 38H42L36.5 64Q35 70 30 70H6Q-1 70 .7 63L4.5 44H2Z',
    'M48 38H81Q88 38 86 45L84 55Q83 60 77 60H57L55 70H44L48 54H72Q74 54 74.5 52L76 44H47Z',
    'M144 38H155L149 70H138Z',
    'M162 38H172Q180 44 184 55L189 38H199L192 70H182Q179 56 171 46L166 70H155Z',
    'M205 38H240L239 44H217L216 51H236L235 56H215L213.5 63H236L235 70H208Q201 70 202 63L207 44H204Z'
  ].map(d => new Path2D(d));
  let width = 1, height = 1, dpr = 1, elapsed = 0, last = 0, raf = 0, visible = false, scene = '';

  function bezier(p, u) {
    const a = 1 - u;
    return [a*a*a*p[0][0]+3*a*a*u*p[1][0]+3*a*u*u*p[2][0]+u*u*u*p[3][0],
      a*a*a*p[0][1]+3*a*a*u*p[1][1]+3*a*u*u*p[2][1]+u*u*u*p[3][1]];
  }
  const curves = [
    [[86.5,23],[99.5,37],[107,59],[107,77.5]],
    [[124,59],[128.5,35],[147,14],[170,5]]
  ];
  // One continuous ribbon mesh per wheel; its two edges become the real V strokes.
  function ribbon(points, thickness, alpha, color) {
    if (alpha < .001 || thickness < .01) return;
    const left = [], right = [];
    points.forEach((p, i) => {
      const a = points[Math.max(0, i-1)], b = points[Math.min(points.length-1, i+1)];
      const length = Math.hypot(b[0]-a[0], b[1]-a[1]) || 1;
      const nx = -(b[1]-a[1])/length*thickness/2, ny = (b[0]-a[0])/length*thickness/2;
      left.push([p[0]+nx,p[1]+ny]); right.push([p[0]-nx,p[1]-ny]);
    });
    ctx.save(); ctx.globalAlpha *= alpha; ctx.fillStyle = color; ctx.beginPath();
    [...left, ...right.reverse()].forEach(([x,y],i) => i ? ctx.lineTo(x,y) : ctx.moveTo(x,y));
    ctx.closePath(); ctx.fill(); ctx.restore();
  }
  function wheel(t, index, shift) {
    const morph = phase(t, 1.12, 1.82);
    const turn = clamp((t-1.12)/.64), decelerate = 1-Math.pow(1-turn,3);
    const finalShape = phase(t,1.57,1.82);
    const grow = Math.pow(clamp((t-.13)/1.0),1.08), hollow = phase(t,.4,1.02);
    const radius = lerp(.8,87,grow);
    const travel = Math.sin(phase(t,.2,1.12)*Math.PI)*10;
    const cx = (index ? 1 : -1)*lerp(2.5,100,grow) + travel;
    const cy = 12 - 9 * phase(t,.3,1.1);
    // Positive angle is clockwise in canvas coordinates. The accelerating phase leaves soft echoes.
    const initialAngle = .35 + t*17 + t*t*6 + index*.8;
    const startAngle = .35 + 1.12*17 + 1.12*1.12*6 + index*.8;
    const terminal = index ? -2.98 : -.81;
    const terminalAngle = terminal + Math.ceil((startAngle-terminal)/TAU)*TAU;
    const angle = t<1.12 ? initialAngle : lerp(startAngle,terminalAngle,decelerate);
    const arcSpan = lerp(lerp(TAU*.995,TAU*.88,phase(t,.3,1.1)),index?1.03:.81,morph);
    const thick = lerp(radius,15.5,hollow);
    const ringRadius = lerp(radius-thick/2,134,morph);
    const arcX=lerp(cx,(index?38:-260)+shift,morph), arcY=lerp(cy,index?54:66,morph);
    const color = index ? green : white;
    const points = [];
    for (let j=0;j<=100;j++) {
      const u=j/100, a=angle+arcSpan*u;
      const target=bezier(curves[index],u);
      points.push([lerp(arcX+ringRadius*Math.cos(a),target[0]*1.78-316+shift,finalShape),
        lerp(arcY+ringRadius*Math.sin(a),target[1]*1.78-72,finalShape)]);
    }
    const emerge = phase(t,0,.16);
    // Subtle radial motion trails, removed completely as the wheels become the mark.
    const trail = phase(t,.15,.6)*(1-phase(t,1.12,1.6));
    for (let echo=3;echo>0;echo--) {
      const trace=Array.from({length:80},(_,j)=>{
        const a=angle-echo*.16+arcSpan*j/79;
        return [cx+(ringRadius+echo*2.1)*Math.cos(a)-echo*1.5,cy+(ringRadius+echo*2.1)*Math.sin(a)];
      });
      ribbon(trace, 1.1, emerge*trail*(.24-echo*.045),color);
    }
    // The rotating tonal wedge makes rotation visible even while the dots are almost solid disks.
    const rotatingFill=ctx.createConicGradient(angle,arcX,arcY);
    rotatingFill.addColorStop(0,color);rotatingFill.addColorStop(.57,color);
    rotatingFill.addColorStop(.82,index?'#075834':'#69766e');
    rotatingFill.addColorStop(.99,color);rotatingFill.addColorStop(1,color);
    ribbon(points,lerp(thick,18.3,morph),emerge,morph<.98?rotatingFill:color);
    if (trail>.01 && morph<.98) {
      ctx.save();ctx.globalAlpha*=trail*(1-morph)*.27;ctx.strokeStyle=color;ctx.lineWidth=.7;
      for (let j=0;j<18;j++) {
        const a=angle+j/18*TAU;ctx.beginPath();ctx.moveTo(cx+Math.cos(a)*5,cy+Math.sin(a)*5);
        ctx.lineTo(cx+Math.cos(a)*(ringRadius-9),cy+Math.sin(a)*(ringRadius-9));ctx.stroke();
      }
      ctx.beginPath();ctx.arc(cx,cy,3.2,0,TAU);ctx.fillStyle=color;ctx.fill();ctx.restore();
    }
    if (t>.25 && t<1.4) {
      const strength=phase(t,.25,.7)*(1-phase(t,1.05,1.4));
      ctx.save();ctx.lineWidth=.7;
      for(let j=0;j<8;j++) {
        ctx.strokeStyle=index?`rgba(0,188,99,${strength*.055})`:`rgba(243,247,244,${strength*.05})`;
        const y=cy+(j-3.5)*18;
        ctx.beginPath();ctx.moveTo(cx-radius-55-j*9,y);ctx.lineTo(cx-radius-9,y);ctx.stroke();
      }ctx.restore();
    }
  }
  function wordmark(t, shift) {
    const appear=phase(t,1.25,1.85);
    if(appear<=0)return;
    ctx.save();ctx.translate(-316+shift,-72);ctx.scale(1.78,1.78);
    // The word opens outwards from the V: UP to the left and INE to the right.
    letters.forEach((path,i)=>{
      const reveal=phase(t,1.25+(i===0?.06:i===1?0:(i-2)*.025),1.78+(i===0?.07:0));
      ctx.save();ctx.beginPath();
      if(i<2)ctx.rect(90*(1-reveal),-10,90*reveal+1,110);
      else ctx.rect(136,-10,110*reveal,110);
      ctx.clip();ctx.globalAlpha*=reveal;ctx.fillStyle=white;ctx.fill(path);ctx.restore();
    });ctx.restore();
  }
  function anniversary(t) {
    const reveal=phase(t,1.98,2.6);
    if(reveal<=0)return;
    ctx.save();ctx.globalAlpha*=reveal;
    ctx.translate(0,12*(1-reveal));
    // A single rolling green stroke completes the zero after the brand is legible.
    ctx.strokeStyle=white;ctx.lineWidth=14;ctx.lineJoin='miter';ctx.lineCap='butt';
    ctx.beginPath();ctx.moveTo(161,-30);ctx.lineTo(186,-48);ctx.lineTo(186,76);
    ctx.setLineDash([154*phase(t,1.98,2.36),1000]);ctx.stroke();
    ctx.setLineDash([]);ctx.strokeStyle=green;ctx.lineWidth=14;ctx.beginPath();
    ctx.ellipse(260,14,42,65,0,-Math.PI/2,-Math.PI/2+TAU*phase(t,2.08,2.6));ctx.stroke();
    ctx.globalAlpha*=phase(t,2.42,2.6);ctx.fillStyle='#7c9d89';ctx.font='8px Uv4Inter,sans-serif';
    ctx.textAlign='center';ctx.letterSpacing='2px';ctx.fillText('2016 — 2026',232,108);
    ctx.restore();
  }
  function render() {
    const time = poster || reduced.matches ? END : elapsed % CYCLE;
    const t=time/1000, opacity=1-phase(time,END+HOLD,CYCLE);
    const current=time>=END&&time<END+HOLD?'hold':time>=END+HOLD?'fade':t<.15?'spark':t<1.12?'spin':t<1.82?'form':t<1.98?'logo':'anniversary';
    if(scene!==current) {
      scene=current;root.dataset.scene=scene;
      root.querySelector('[data-art-word]').textContent=({spark:root.dataset.captionSpark,spin:root.dataset.captionSpin,form:root.dataset.captionForm,logo:root.dataset.captionLogo,anniversary:root.dataset.captionHold,hold:root.dataset.captionHold,fade:root.dataset.captionReset})[scene];
    }
    root.dataset.elapsedMs=String(Math.round(time));root.dataset.cycle=String(Math.floor(elapsed/CYCLE));
    root.style.setProperty('--finish',String(phase(t,1.98,2.6)));
    ctx.setTransform(dpr,0,0,dpr,0,0);ctx.clearRect(0,0,width,height);
    const scale=Math.min(width/700,height/360)*.98;
    ctx.save();ctx.translate(width*.5,height*.45);ctx.scale(scale,scale);ctx.globalAlpha=opacity;
    const shift=90*(1-phase(t,1.85,2.5));
    wordmark(t,shift);wheel(t,0,shift);wheel(t,1,shift);anniversary(t);
    ctx.restore();root.dataset.canvasReady='true';
  }
  function suspend(){cancelAnimationFrame(raf);raf=0;last=0;}
  function tick(now){raf=0;if(!visible||document.hidden||reduced.matches)return;if(last)elapsed+=Math.min(now-last,80);last=now;render();raf=requestAnimationFrame(tick);}
  function wake(){if(!poster&&visible&&!document.hidden&&!reduced.matches&&!raf){last=0;raf=requestAnimationFrame(tick);}}
  function resize(){const r=canvas.getBoundingClientRect();if(r.width<1||r.height<1)return;width=r.width;height=r.height;dpr=Math.min(devicePixelRatio||1,2);canvas.width=Math.round(width*dpr);canvas.height=Math.round(height*dpr);render();wake();}
  document.addEventListener('visibilitychange',()=>document.hidden?suspend():wake());
  reduced.addEventListener('change',()=>{suspend();render();wake();});
  if('IntersectionObserver'in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;visible?wake():suspend();},{threshold:.08}).observe(root);else visible=true;
  new ResizeObserver(resize).observe(canvas);resize();
})();
